import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    IResponseData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {ThorGameAssets} from "./ThorGameAssets";
import {Thor} from "./Thor";
import {ThorSoundConfig} from "./ThorSoundConfig";
import {ThorGameMode} from "./gamemode/ThorGameMode";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";

export class ThorPromoPanelConfig implements PromoPanelGameConfiguration {
    public static scatterNearWinFlag: boolean = true;
    private roundWin: number = 0;

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Thor",
            hasActionSpin: true,
            graphics: {backgroundTextureName: ThorGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: any, bet: number, prevResponse: any): ASWinData => {
                ThorPromoPanelConfig.scatterNearWinFlag = false;
                const spinWin: number = this.getWin(response, bet, prevResponse);
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    totalSpinWinnings: spinWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response, spinWin),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: false
                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            Thor.sound.playEffect(ThorSoundConfig.instance.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            Thor.sound.playEffect(ThorSoundConfig.instance.AS_WIN_BIG);
        }
    }

    onPlayBonusInGame(data: any) {
        this.restoreBaseGameReels(data);
        EventHandler.dispatchEvent(new GameEvent(ServerEvent.GAME_DATA_RECEIVED, data));
        Thor.keypad.setWin(data.accumulatedRoundWin, true, (Thor.api.gameClientConfiguration.belowStakeWinRestriction && data.accumulatedRoundWin > data.playedBetValue));
        EventHandler.dispatchEvent(new GameEvent(ScreenEvent.GAME_START));
        ThorPromoPanelConfig.scatterNearWinFlag = true;
    }

    isLegalStopOnBonusMode(response: IResponseData): boolean {
        return (response.mode === ThorGameMode.NORMAL && response.nextMode === ThorGameMode.FREESPIN) ||
            (response.mode === ThorGameMode.RESPIN && response.nextMode === ThorGameMode.FREESPIN) ||
            (response.mode === ThorGameMode.NUDGE_RESPIN && response.nextMode === ThorGameMode.FREESPIN) ||
            (response.mode === ThorGameMode.SCATTER_RESPIN && response.nextMode === ThorGameMode.FREESPIN);
    }

    private isBigWin(response: any, spinWin: number): boolean {
        const win: number = spinWin;
        const playedBetValue = response.playedBetValue;
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);
        return winRatio >= 15;
    }

    private getWin(response: any, bet: number, prevData: any): number {
        let result: number = 0;
        this.roundWin += response.totalSpinWinnings;

        if (!response.nextMode.includes("RESPIN")) {
            result = this.roundWin;
            this.roundWin = 0;
        }

        return result;
    }

    private getFeatureName(response: any): string {
        if (response.nextMode == ThorGameMode.FREESPIN || response.mode == ThorGameMode.FREESPIN || response.nextMode == ThorGameMode.NUDGE_RESPIN_FS || response.mode == ThorGameMode.NUDGE_RESPIN_FS) {
            return "ASGARD SPINS";
        }
        return "";
    }

    private isFreeSpinTriggered(response: any): boolean {
        return (response.mode === ThorGameMode.NORMAL || response.mode === ThorGameMode.NUDGE_RESPIN || response.mode === ThorGameMode.SCATTER_RESPIN || response.mode === ThorGameMode.RESPIN) && response.nextMode === ThorGameMode.FREESPIN;
    }

    private restoreBaseGameReels(data: any): void {
        const reels: string[][] = data.evaluatedReels;
        let sym: StateReelSymbol;
        for (let i: number = 0; i < reels.length; i++) {
            for (let j: number = 0; j < reels[i].length; j++) {
                sym = (Reels.getSymbol(i, j)!);
                sym.replaceWith(reels[i][j], i);
                if (sym.symName === "X") {
                    sym.setVisibility(false);
                }
            }
        }
    }

    private isRoundComplete(response: any): boolean {
        return [ThorGameMode.FREESPIN, ThorGameMode.NORMAL].indexOf(response.nextMode) > -1;
    }

    private isBonusEnd(response: any): boolean {
        return (response.mode === ThorGameMode.FREESPIN || response.mode === ThorGameMode.NUDGE_RESPIN_FS) && response.nextMode === ThorGameMode.NORMAL;
    }

}